const styles = ({ typography, content, breakpoints }) => ({
  content: {
    minHeight: typography.pxToRem(400),
    ...content.calc('padding', ['top', 'bottom'], '/', '2'),
  },
  image: {
    width: '100%',

    [breakpoints.up('sm')]: {
      width: '70%',
    },
    [breakpoints.up('lg')]: {
      width: typography.pxToRem(500),
      height: typography.pxToRem(375),

      '& img': {
        objectFit: 'contain !important',
      },
    },
  },
});

export default styles;
